import { doDelete, doGet, doPost, doPut } from '../http/httpHelper';

const unwrap = (response) => {
    if (response?.httpStatus && response.httpStatus >= 400) {
        const message = response?.body?.message || response?.body?.error || 'Erro ao comunicar com empresas.';
        throw new Error(message);
    }

    return response?.body ?? response;
};

export const listCompanies = async () => unwrap(await doGet('/companies'));

export const getCompanyById = async (id) => unwrap(await doGet(`/companies/${id}`));

export const createCompany = async (company) => unwrap(await doPost('/companies', company));

export const editCompany = async (id, company) => unwrap(await doPut(`/companies/${id}`, company));

export const delCompany = async (id) => doDelete(`/companies/${id}`);

export const listUserCompanies = async () => unwrap(await doGet('/usercompany'));

export const createUserCompany = async (data) => unwrap(await doPost('/usercompany', data));
